module.exports = __webpack_public_path__ + "static/media/ratio.720ad937.png";